import { Stack, Typography } from "@mui/material"
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import { ThemeContext } from "../../../Shared/Theme/ThemeContext"
import { useContext } from "react";

export function AdminButton({...params}){

    const { mode } = useContext(ThemeContext);

    let adminButtonState = params.adminButtonState
    let setAdminButtonState = params.setAdminButtonState
    let handleClick = params.handleClick

    let lightColors = ["#02203B", "#06569D", "#138BF6"  ]
    let darkColors = ["#138BF6", "#75BCFA", "#D8ECFD"  ]

    let onButtonPage = false
    let url = window.location.pathname
    if (url === '/adminpage') onButtonPage = true

    const handleButtonHover = (event) => {
        event.preventDefault()
        if (onButtonPage) setAdminButtonState('hover')
        else if (adminButtonState !== 'active') setAdminButtonState('hover')
    }

    const handleButtonMouseOut = (event) => {
        event.preventDefault()
        setAdminButtonState('default')
        if (onButtonPage) setAdminButtonState('active')
        else if (adminButtonState !== 'active') setAdminButtonState('default')
    }

    let adminButtonColor = ''

    if (mode === 'light'){
        if (adminButtonState === 'active') adminButtonColor = lightColors[0]
        else if (adminButtonState === 'default') adminButtonColor = lightColors[1]
        else if (adminButtonState === 'hover') adminButtonColor = lightColors[2]
    } 
    else if (mode === 'dark'){
        if (adminButtonState === 'active') adminButtonColor = darkColors[0]
        else if (adminButtonState === 'default') adminButtonColor = darkColors[1]
        else if (adminButtonState === 'hover') adminButtonColor = darkColors[2]
    } 

    let labelFormatting = params.labelFormatting
    let labelStyling = {color: adminButtonColor}

    return (
        <Stack width={'71px'} height={'55px'} direction={'column'} alignItems={'center'} zIndex={100}
            onMouseOut={(event) => handleButtonMouseOut(event)} 
            onMouseOver={(event) => handleButtonHover(event)}
            onClick={(event) => handleClick(event)}>
            <AdminPanelSettingsIcon sx={{color: adminButtonColor, paddingBottom: '10px', width: '33px', height: '45px'}}/>
            <Typography sx={[labelFormatting, labelStyling]}>Admin</Typography>
        </Stack>
    )
}
